<aslib-title Text="Importação / Planilha IPM" SubText="Importar" Icon="fa fa-dollar"></aslib-title>

<form novalidate [formGroup]='formImprtarPlanilha'>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Ano de Referência do Índice:</label>
    <div class="controls col-md-2">
      <select [(ngModel)]="anoSelected"  formControlName="AnoReferencia" class="form-control" >
        <option [ngValue]=undefined>Selecione</option>
        <option *ngFor="let ano of listaAno" [ngValue]="ano">{{ano.Descricao}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Arquivo do TCE:</label>
    <div class="controls col-md-6">
      <input class="form-control" type="file" #fileInput />
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-9 offset-md-3">
      <button type="submit" class="btn btn-primary" [disabled]="!formImprtarPlanilha.valid" (click)="ImportarPlanilhaIpm(modalMensagem)" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Confirmar </button>
    </div>
  </div>

</form>
<aslib-modal #modalMensagem></aslib-modal>



// WEBPACK FOOTER //
// ./src/app/ipm/importacao-planilha-ipm/importar-planilha-ipm.component.html